import { useTranslation } from 'react-i18next';
import { BotBubble } from './BotBubble';
import { UserBubble } from './UserBubble';

interface LessonTurnProps {
  prompt: string;
  lessons: string[];
  showTypingDots: boolean;
}

export function LessonTurn({
  prompt,
  lessons,
  showTypingDots,
}: LessonTurnProps) {
  const { t } = useTranslation('debriefV2');
  return (
    <>
      <BotBubble showTypingDots={showTypingDots}>{prompt}</BotBubble>
      {lessons.map((lesson, lessonIndex) => (
        <FollowUpPair
          key={lessonIndex}
          lesson={lesson}
          followUp={t('deepDive.lessonsFollowUp')}
        />
      ))}
    </>
  );
}

interface FollowUpPairProps {
  lesson: string;
  followUp: string;
}

function FollowUpPair({ lesson, followUp }: FollowUpPairProps) {
  return (
    <>
      <UserBubble>{lesson}</UserBubble>
      <BotBubble showTypingDots={false}>{followUp}</BotBubble>
    </>
  );
}
